import React from 'react'
import PropTypes from 'prop-types'
import Img from '../Img'

const PostImage = ({ image }) => {
  if (!image) return null

  return (
    <Img
      layout="responsive"
      dataTestId="post-image"
      alt={image.title}
      className="h-full w-full object-cover"
      src={image.url}
      height={image.details.image.height}
      width={image.details.image.width}
      title={image.title}
      priority={true}
      styles={{ position: 'relative' }}
    />
  )
}

PostImage.defaultProps = {
  title: '',
  image: null,
}
PostImage.propTypes = {
  title: PropTypes.string,
  image: PropTypes.any,
}

export default React.memo(PostImage)
